import React, { Dispatch, SetStateAction, useMemo, useState } from 'react';
import KeyDates from './KeyDates';
import { getProductionKeyActivities } from '../helpers/productionAssociatedEntitiesUtils';
import AddKeyDatesModal from '../schedule/AddKeyDatesModal';
import { ProductionTypeSuperset } from '../helpers/productionApi';

type AssociatedKeyDatesProps = {
    workspace: ProductionTypeSuperset;
    setWorkspace?: Dispatch<SetStateAction<ProductionTypeSuperset>>;
    isReadOnly?: boolean;
    isSaving?: boolean;
};

export const AssociatedKeyDates = ({ workspace, setWorkspace, isReadOnly, isSaving }: AssociatedKeyDatesProps) => {
    const { plans, keyActivities, reference: workspaceReference } = workspace;

    const [isKeyDatesModalOpen, setIsKeyDatesModalOpen] = useState<boolean>(false);
    const [activityId, setActivityId] = useState<string>('');

    const mappedActivities = useMemo(() => {
        return getProductionKeyActivities({ plans, keyActivities });
    }, [keyActivities, plans]);

    return (
        <>
            <KeyDates
                activities={mappedActivities}
                onAdd={() => setIsKeyDatesModalOpen(true)}
                onEdit={(id) => {
                    setIsKeyDatesModalOpen(true);
                    setActivityId(id);
                }}
                isReadOnly={isReadOnly}
                isSaving={isSaving}
            />
            {isKeyDatesModalOpen && (
                <AddKeyDatesModal
                    open
                    onClose={() => {
                        setIsKeyDatesModalOpen(false);
                        setActivityId('');
                    }}
                    productionId={workspaceReference.id}
                    planId={workspace?.plans?.[0]?.identity?.id}
                    activityId={activityId}
                    viewState={workspace}
                    setViewState={setWorkspace}
                />
            )}
        </>
    );
};
